/**
 * Created by hp on 2017/8/16.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import qs from 'qs';
import {Cells, Cell, CellBody, CellFooter, Switch, Button} from 'react-weui';
import { Link } from 'react-router'


class RelaySettingMoney extends Component {
    constructor(props) {
        super(props);

        this.handleToggleSetting = this.handleToggleSetting.bind(this);
        this.handleToggleRelayMoney = this.handleToggleRelayMoney.bind(this);
        this.handleRelayConfirm = this.handleRelayConfirm.bind(this);

        const {relayInfo} = this.props;
        this.state = {
            showSettingMoney: relayInfo.can_public_relay || false,
            relayMoney: (relayInfo.relay_fee / 100) || 0,
        }
    }

    handleRelayConfirm() {
        const {id, relayType} = this.props;
        const {relayMoney, showSettingMoney} = this.state;

        let fee = parseInt((relayMoney * 100).toFixed(0), 10);
        if (!showSettingMoney) {
            fee = 0;
        }
        let data = {can_public_relay: showSettingMoney, relay_fee: fee};
        axios.post(`/api/relay/${relayType}/${id}/edit`, qs.stringify(data)).then(res => {
            if (res.data.code === 0) {
                this.context.page.showAlert('更新成功');
            } else {
                this.context.page.showAlert(res.data.msg);
            }
        });
    }

    handleToggleRelayMoney(e) {
        let money = e.target.value;
        this.setState({relayMoney: money});
    }

    handleToggleSetting() {
        this.setState({showSettingMoney: !this.state.showSettingMoney});
    }

    render() {
        const {showSettingMoney, relayMoney} = this.state;
        const {title, description, relayType, id} = this.props;

        return (
            <div className="relay-setting-money">
                <Cells className="cel-brb-none">
                    <Cell>
                        <CellBody>
                            <p className="title">{title}</p>
                            <p className="desc">{description}</p>
                        </CellBody>
                        <CellFooter>
                            {showSettingMoney ?
                                <Switch onClick={this.handleToggleSetting} defaultChecked/>
                                :
                                <Switch onClick={this.handleToggleSetting}/>
                            }
                        </CellFooter>
                    </Cell>
                </Cells>

                {/* <Cells className={"cel-brt-none cel-brb-none " + (showSettingMoney ? "wk-show" : "wk-hide")}>
                    <Cell>
                        <CellBody>
                            {/* <div className="rl-fee">
                                <p className="rlf-title">转播权费用</p>
                                <div className="rlf-money">
                                    <input className="rlfm-input" onChange={this.handleToggleRelayMoney}
                                           value={relayMoney}/>
                                    <span className="rlfm-text">元</span>
                                </div>
                            </div> */}

                            {/* {relayType === 'lecture' &&
                            <div className="rl-text">
                                <p>1. 转播权费用向转播者收取；</p>
                                <p>2. 转播者可在转播间收听课程，因此付费课程的转播权费用默认为课程学费，并建议付费课程不要免费转播；</p>
                                <p>
                                    3. 转播分成同步
                                    <Link to={`/lecture/${id}/edit/pay`}>分销分成</Link>，
                                    设置高分成，才会有更多人转播。
                                </p>
                            </div>
                            }

                            {relayType === 'channel' &&
                            <div className="rl-text">
                                <p>1. 转播权费用向转播者收取；</p>
                                <p>2. 转播者可在转播间收听课程，因此付费专栏的转播权费用默认为专栏学费，并建议付费专栏不要免费转播；</p>
                                <p>
                                    3. 转播分成同步
                                    <Link to={`/channel/${id}/edit/pay`}>分销分成</Link>，
                                    设置高分成，才会有更多人转播。
                                </p>
                            </div>
                            } */}
                        {/* </CellBody>
                    </Cell>
                </Cells>  */}

                <div className="btn-confirm wk-border-line-after">
                    <Button onClick={this.handleRelayConfirm}>确定</Button>
                </div>

                {relayType === 'lecture' &&
                <div className="relay-description">
                    <p className="rly-title">转载说明</p>
                    <p>1. 转载分成同步<Link to={`/lecture/${id}/edit/pay`} style={{textDecoration:'underline',color: '#586C94'}}>分销分成</Link>，设置高分成，才会有更多人转载；</p>
                    <p>2. 转载付费课程产生的购买收益，会给转载方分成；</p>
                    <p>3. 转载者成功申请转载你的课程后，立即创建转载间；</p>
                    <p>4. 主直播间的语音，文字，图片，PPT等都会同步到转载间，同时转载间的用户评论能同步到主直播间；</p>
                    <p>5. 转载课程不支持分销，优惠码，限时特价功能；</p>
                    <p>6. 转载者需要购买课程，才可收听课程</p>
                </div>
                }

                {relayType === 'channel' &&
                <div className="relay-description">
                    <p className="rly-title">转载说明</p>
                    <p>1. 转载分成同步<Link to={`/channel/${id}/edit/pay`} style={{textDecoration:'underline',color: '#586C94'}}>分销分成</Link>，设置高分成，才会有更多人转载；</p>
                    <p>2. 转载付费专栏产生的购买收益，会给转载方分成；</p>
                    <p>3. 转载者成功申请转载你的专栏后，立即创建转载间；</p>
                    <p>4. 主直播间专栏的所有课程都会同步到转载间；</p>
                    <p>5. 转载专栏不支持分销，优惠码，限时特价功能；</p>
                    <p>6. 转载者需要购买专栏，才可收听课程</p>
                </div>
                }
            </div>
        )
    }
}

RelaySettingMoney.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    id: state.relaySetting.id,
    relayInfo: state.relaySetting.relay_info,
}))(RelaySettingMoney)



// WEBPACK FOOTER //
// ./src/components/relaySetting/RelaySettingMoney.js